import type { WorkOrderLetterAddress } from "../../../../../api/kehrblatt/letters"
import { formatPropertyUnitLabel } from "../../../../../_shared/_logic/unit-labels"
import { formatPropertyObjectAddressLine } from "../object-tags"

export type LetterOrderReference = {
  property_address?: Partial<WorkOrderLetterAddress> | null
  property_label?: string | null
  property_unit_type?: string | null
  unit_label?: string | null
  order_type_internal_label?: string | null
  work_order_label?: string | null
  order_number?: string | number | null
}
export const buildLetterOrderTag = (row: LetterOrderReference) => {
  const address = row.property_address
  const label = formatPropertyObjectAddressLine(address, row.property_label || "Liegenschaft")
  const unit = row.unit_label
    ? formatPropertyUnitLabel(row.unit_label, row.property_unit_type)
    : row.property_unit_type === "RESIDENTIAL"
      ? "Wohneinheit"
      : "Gebäudeeinheit"

  return {
    label,
    subLabel: [unit, row.order_type_internal_label || row.work_order_label]
      .filter(Boolean)
      .join(" · "),
    numberLabel: String(row.order_number ?? ""),
  }
}
